/** OperationDetailDrawer — drill-down d'une opération. */
import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Badge } from "../ui/badge";

export default function OperationDetailDrawer({ op, onClose }) {
  if (!op) return null;
  const health = op.events.find((e) => e.event_type === "health_check_ok") || op.events.find((e) => e.event_type === "install_failed");
  const migrations = op.events.find((e) => e.event_type === "migrations_applied");
  const backup = op.events.find((e) => e.event_type === "backup_created");
  return (
    <Dialog open={true} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="op-detail">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            Détail de l'opération
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div><p className="text-muted-foreground text-xs">Op ID</p><p className="font-mono text-xs break-all">{op.operation_id}</p></div>
            <div><p className="text-muted-foreground text-xs">Initié par</p><p>{op.actor || "—"}</p></div>
            <div><p className="text-muted-foreground text-xs">Début</p><p>{new Date(op.started_at).toLocaleString()}</p></div>
            <div><p className="text-muted-foreground text-xs">Fin</p><p>{new Date(op.ended_at).toLocaleString()}</p></div>
            <div><p className="text-muted-foreground text-xs">Durée</p><p>{Math.round(op.duration_ms / 100) / 10}s</p></div>
            <div><p className="text-muted-foreground text-xs">Versions</p><p className="font-mono text-xs">{op.version_from} → {op.version_to}</p></div>
          </div>

          <Section title="Health-check">
            {health ? (
              <ul className="text-sm space-y-1">
                {Object.entries(health.payload || {}).map(([k, v]) => (
                  <li key={k}><span className="text-muted-foreground">{k}:</span> <span className="font-mono text-xs">{typeof v === "object" ? JSON.stringify(v) : String(v)}</span></li>
                ))}
              </ul>
            ) : <p className="text-sm text-muted-foreground">—</p>}
          </Section>

          <Section title="Migrations">
            {migrations ? (
              <div className="text-sm">
                <p><span className="text-muted-foreground">Appliquées :</span> {migrations.payload?.applied?.join(", ") || "aucune"}</p>
                <p><span className="text-muted-foreground">Attendues :</span> {migrations.payload?.expected?.join(", ") || "aucune"}</p>
              </div>
            ) : <p className="text-sm text-muted-foreground">Aucune migration exécutée.</p>}
          </Section>

          <Section title="Backup">
            {backup ? (
              <ul className="text-sm space-y-1">
                <li><span className="text-muted-foreground">Release archive :</span> <code className="text-xs">{backup.payload?.release_archive || "aucun"}</code></li>
                <li><span className="text-muted-foreground">Database dump :</span> <code className="text-xs">{backup.payload?.database_dump_dir || "aucun"}</code></li>
                {backup.payload?.warnings?.length > 0 && (
                  <li className="text-amber-700">Warnings : {backup.payload.warnings.join(" • ")}</li>
                )}
              </ul>
            ) : <p className="text-sm text-muted-foreground">—</p>}
          </Section>

          <Section title="Timeline complète">
            <ol className="space-y-2">
              {op.events.map((e) => (
                <li key={e.event_id} className="border-l-2 border-border pl-3">
                  <div className="flex items-center gap-2">
                    <Badge variant="outline">{e.event_type}</Badge>
                    <span className="text-xs text-muted-foreground">{new Date(e.at).toLocaleTimeString()}</span>
                  </div>
                  {e.payload && Object.keys(e.payload).length > 0 && (
                    <details className="text-xs mt-1">
                      <summary className="cursor-pointer text-muted-foreground">payload</summary>
                      <pre className="bg-secondary/60 rounded p-2 overflow-auto">{JSON.stringify(e.payload, null, 2)}</pre>
                    </details>
                  )}
                </li>
              ))}
            </ol>
          </Section>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function Section({ title, children }) {
  return (
    <div className="border-t pt-3">
      <p className="font-medium text-sm mb-2">{title}</p>
      {children}
    </div>
  );
}
